import '../assets/NcAppSettingsSection-DU9FOAnJ.css';
import { defineComponent, useSlots, inject, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { l as logger } from "./logger-D3RVzcfQ.mjs";
import { u as useAppSettingsDialog, A as APP_SETTINGS_LEGACY_DESIGN_KEY } from "./useAppSettingsDialog-C73Wx6iQ.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppSettingsSection",
  props: {
    name: null,
    description: null,
    id: null,
    order: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { registerSection, unregisterSection } = useAppSettingsDialog();
    const legacy = inject(APP_SETTINGS_LEGACY_DESIGN_KEY);
    const htmlId = computed(() => "settings-section_" + props.id);
    watch(() => props.id, () => {
      if (!/^[a-z0-9\-_]+$/.test(props.id)) {
        logger.warn(`Invalid id prop: ${props.id}. Only alphanumeric, dash and underscore are allowed.`);
      }
    }, { immediate: true });
    watch([() => props.id, () => props.name, () => props.order], ([newId, newName, newOrder], [oldId, ,]) => {
      unregisterSection(oldId);
      registerSection(newId, newName, newOrder, slots?.icon?.());
    });
    onMounted(() => {
      registerSection(props.id, props.name, props.order, slots?.icon?.());
    });
    onBeforeUnmount(() => {
      unregisterSection(props.id);
    });
    return { __sfc: true, props, slots, registerSection, unregisterSection, legacy, htmlId };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("section", { staticClass: "app-settings-section", class: { "app-settings-section__legacy": _setup.legacy }, attrs: { "id": _setup.htmlId, "aria-labelledby": `${_setup.htmlId}--label` } }, [_c("h3", { staticClass: "app-settings-section__name", attrs: { "id": `${_setup.htmlId}--label` } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _c("div", { staticClass: "app-settings-section__description" }, [_vm._v(" " + _vm._s(_vm.description) + " ")]), _c("div", { staticClass: "app-settings-section__content" }, [_vm._t("default")], 2), _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6b7bb88c"
);
const NcAppSettingsSection = __component__.exports;
export {
  NcAppSettingsSection as N
};
//# sourceMappingURL=NcAppSettingsSection-CsGyNFSh.mjs.map
